// extracted by mini-css-extract-plugin
module.exports = {"container":"Categories_container__24mPa","fade-in":"Categories_fade-in__nLnQe","gridContainer":"Categories_gridContainer__3IAWJ"};